import clsx from 'clsx'
import { forwardRef, HTMLProps } from 'react'
import { ClassName } from 'types/props'

import classes from './index.module.scss'

export interface InputProps extends HTMLProps<HTMLInputElement>, ClassName {
  hasError?: boolean
  isDisabled?: boolean
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, hasError = false, isDisabled = false, ...props }: InputProps, ref) => (
    <input
      {...props}
      ref={ref}
      className={clsx(className, classes.root, {
        [classes.hasError]: hasError
      })}
      disabled={isDisabled}
    />
  )
)
